module.exports = __webpack_public_path__ + "img/16-about.0eb50a8f.jpg";